import React from 'react'
import { ZdsIcon, ZdsTypography } from '@zera/components'
import { Container } from './styles'

type ErrorIndicatorProps = {
  show: boolean
}

export const ErrorIndicator = ({ show }: ErrorIndicatorProps): JSX.Element => {
  if (!show) {
    return <></>
  }
  return (
    <Container>
      <ZdsIcon src="MiWarningCircle" color="red400" />
      <ZdsTypography variant="caption300" color="red400">
        Falha no envio do feedback. Tente novamente
      </ZdsTypography>
    </Container>
  )
}
